import WRAP from "WRAP-JS";

/* eslint-disable */
const superLayer = WRAP.Geo.Layer;
WRAP.Geo.Layer = function(name) {
  const layer = new superLayer(name);
  const superSetRespondable = layer.setRespondable;
  layer.setRespondable = function(flag, all) {
    superSetRespondable.call(this, flag);
    if (!!all) {
      this._hit_all = true;
    }
  }
  return layer;
}

Object.assign(WRAP.Geo.View.prototype, {
  hit: function (point) {
    var view = this;
    var x = point.x;
    var y = point.y;
    var hits = [];

    var ll = this.point([x, y]);
    if (!ll || isNaN(ll[0]) || isNaN(ll[1]))
      return hits;
    var rp = this.renderPoint(ll);
    if (view.band)
      rp[0] = (rp[0] + view.band * 256) % view.band;
    if (0 <= rp[0] && rp[0] < view.extent[0] && 0 <= rp[1] && rp[1] < view.extent[1]) {
      var context = view.context;
      if (!this.seal_screen)
        this.seal_screen = new WRAP.Geo.Screen();
      if (!view.context_sealed) {
        view.seal_count = 0;
        this.seal_screen.init(this);
        for (var i = 0; i < view.layers.length; i++) {
          var layer = view.layers[i];
          if (layer.visible() && (layer._respondable || layer._tooltip_group)) {
            if (!layer._seal_screen)
              layer._seal_screen = new WRAP.Geo.Screen();
            layer._seal_screen.init(this);
          }
        }

        var dl = view.dl;
        if (dl) {
          for (var i = 0; i < dl.length; i++) {
            var feature = dl[i];
            var layer = feature.layer;
            var screen = ((layer._respondable || layer._tooltip_group) && layer._seal_screen) || this.seal_screen;
            feature.seal(screen);
          }
        }
        view.context_sealed = true;

        if (view.check_screen) {
          var canvas = document.createElement("canvas");
          canvas.width = context.canvas.width;
          canvas.height = context.canvas.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(context.canvas, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
          ctx.drawImage(this.seal_screen.canvas, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
          view.map.render(canvas, context.origin);
        }

      }
      var screens = [this.seal_screen];
      for (var i = 0; i < view.layers.length; i++) {
        var layer = view.layers[i];
        if (layer.visible() && (layer._respondable || layer._tooltip_group) && layer._seal_screen)
          screens.push(layer._seal_screen)
      }

      for (var i = 0; i < screens.length; i++) {
        var screen = screens[i];
        var sealed = screen.get(rp);
        if (sealed) {
          sealed.forEach(sealed => {
            var feature = sealed.feature;
            hits.push({ layer: feature.layer, feature: feature, x: x, y: y, pixel: sealed.pixel, index: sealed.index });

            if (sealed.pixel) {
              var p = view.point([x, y]);
              var v;
              var layer = feature.layer;
              if (layer && layer._renderer && layer._renderer.getValue) {
                var content = layer._content;
                var context = this.context;
                var data = layer._data;
                v = layer._renderer.getValue(content, context, data, new WRAP.Geo.Point(p[1] * 60, p[0] * 60));
              }
              feature.geo = {
                geometry: {
                  type: "Point",
                  coordinates: p
                },
                properties: v
              };
            }
          });
        }
      }
      //console.log("hit ("+x+","+y+") -> "+sealed);
    }
    hits.sort(function (a, b) {
      if (a.index > b.index) return -1;
      if (a.index < b.index) return 1;
      return 0;
    });
    return hits;
  },
});

const orgScreen = WRAP.Geo.Screen;
WRAP.Geo.Screen = function() {

  const view = WRAP.Geo.currentView();
  const descriptor = Object.getOwnPropertyDescriptor(view, 'context_sealed');
  if (descriptor?.get === undefined) {
    WRAP.Geo.Screen.screens = [];
    Object.defineProperty(view, 'context_sealed', {
      get() {
        return this._context_sealed;
      },
      set(newValue) {
        const oldValue = this._context_sealed;
        this._context_sealed = newValue;
        if (newValue && oldValue !== newValue) {
          WRAP.Geo.Screen.screens.forEach(screen => {
            const newSVGString = screen.ctx.join('');
            if (newSVGString !== screen.latestSVGString) {
              screen.svg.innerHTML = '';
              screen.svg.innerHTML = newSVGString;
              screen.latestSVGString = newSVGString;
            }
          });
          WRAP.Geo.Screen.screens.splice(0);
        }
      }
    });
  }
  const svg = this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  this.ctx = [];
  this.canvas = {};
  Object.assign(svg.style, {
    position: 'absolute',
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    // zIndex: -1,
    // opacity: 0,
  });
  document.getElementById('map-container').appendChild(svg);
  this.id_bias = 1000;
  let dispatch = true;
  if (dispatch) {
    const parent = document.getElementById('map-container');
    const map_canvas = parent.getElementsByTagName('canvas')[0];
    ['mousedown', 'mousemove', 'mouseup'].forEach(eventType => {
      svg.addEventListener(eventType, event => {
        const eventCopy = document.createEvent("MouseEvents");
        eventCopy.initMouseEvent(event.type, event.bubbles, event.cancelable, event.view, event.detail,
          event.pageX || event.layerX, event.pageY || event.layerY, event.clientX, event.clientY, event.ctrlKey, event.altKey,
          event.shiftKey, event.metaKey, event.button, event.relatedTarget);
        map_canvas.dispatchEvent(eventCopy);
      })
    });
    [/* 'DOMMouseScroll',  */'mousewheel'/* , 'wheel' */].forEach(eventType => {
      svg.addEventListener(eventType, event => {
        const eventCopy = new WheelEvent(eventType, {
          deltaX: event.deltaX,
          deltaY: event.deltaY,
          deltaZ: event.deltaZ,
          deltaMode: event.deltaMode,
          wheelDelta: event.wheelDelta,
          detail: event.detail
        });
        map_canvas.dispatchEvent(eventCopy);
      })
    });
  }

  this.init = function(view) {
    // console.log('init');
    WRAP.Geo.Screen.screens.push(this);
    this.start = new Date();
    this.view = view;
    this.projection = view.projection;
    this.zoom = view.context.zoom;
    this.map_scale = view.context.map_scale;
    this.extent = view.context.extent;
    this.origin = view.context.origin;
    this.canvas.width = this.extent[0];
    this.canvas.height = this.extent[1];

    this.svg.setAttributeNS(null, 'viewBox', [0, 0, this.extent[0], this.extent[1]].join(' '));
    this.ctx.splice(0);
    this.features = [];
    this.tile_surface = -1;

    this._fragmentPath = WRAP.Geo.Context.prototype._fragmentPath;
    this._linearize = WRAP.Geo.Context.prototype._linearize;
    this.linearize = WRAP.Geo.Context.prototype.linearize;
  }
};

Object.assign(WRAP.Geo.Screen.prototype, orgScreen.prototype, {
  set: function(feature, tiled) {
    if ( feature.layer && feature.layer._disableInteraction )
      return;
    var id = this.features.length+this.id_bias;
    this.features.push({feature:feature, tiled:tiled, id:id, index:this.view.seal_count++});
    if ( tiled )
      this.tile_surface = this.features.length-1;
    return tiled?null:id;
  },

  get: function(p) {
    let id = -1;
    let ids = [];
    let hit_all = false;

    const point = this.svg.createSVGPoint();
    point.x = p[0];
    point.y = p[1];
    let intersects;
    if (typeof this.svg.getIntersectionList === 'function') {
      const irect = this.svg.createSVGRect();
      irect.width = irect.height = 1;
      irect.x = p[0];
      irect.y = p[1];
      intersects = this.svg.getIntersectionList(irect, null);
    } else {
      intersects = this.svg.childNodes;
    }
    for (let i = intersects.length - 1; i >= 0; i--) {
      const elem = intersects[i];
      const stroke = elem.getAttributeNS(null, 'stroke');
      const fill = elem.getAttributeNS(null, 'fill');
      if (stroke && stroke !== 'none' && elem.isPointInStroke(point) || fill && fill !== 'none' && elem.isPointInFill(point)) {
        let _id = elem.getAttributeNS(null, 'feature') - this.id_bias;
        if ( _id >= 0 && _id < this.features.length ) {
          if (id === -1) {
            id = _id;
          }
          ids.push(_id);
          if (!this.features[id].feature.layer._hit_all) {
            break;
          }
          hit_all = true;
        }
      }
    }

    if ( id < this.tile_surface )
      id = this.tile_surface;
    if (id !== -1) {
      if (hit_all) {
        return ids.map(id => ({ feature:this.features[id].feature, pixel:(id==this.tile_surface), index:this.features[id].index }));
      }
      return [{ feature:this.features[id].feature, pixel:(id==this.tile_surface), index:this.features[id].index }];
    }
    return null;
  },

  drawImageData: function(feature, point, imageData, width, height, offset_x, offset_y, rotation) {
    WRAP.Geo.check(imageData);
    var color = this.set(feature);
    if (!color) return;

    const _drawCanvas = (ctx, ox, oy, width, height) => {
      const attr = [];
      if ( rotation ) {
        const transform = [];
        transform.push(`rotate(${rotation}, ${ox}, ${oy})`);
        attr.push(['transform', transform.join(' ')]);
      }
      attr.push(['x', ox+offset_x]);
      attr.push(['y', oy+offset_y]);
      attr.push(['width', width]);
      attr.push(['height', height]);
      attr.push(['fill', 'yellow']);
      attr.push(['feature', color]);
      ctx.push(
        `<rect ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
      );
    }

    var ctx = this.ctx;
    ctx.fillStyle = color;
    var p = this.view.renderPoint(point);
    var ox = p[0];
    var oy = p[1];

    var size = (width>height?width:height)*1.5;
    var sx = -size;
    var ex = this.svg.viewBox.baseVal.width+size;
    var sy = -size;
    var ey = this.svg.viewBox.baseVal.height+size;
    if ( oy < sy || ey < oy )
      return;
    if ( sx <= ox && ox <= ex )
      _drawCanvas(ctx, ox, oy, width, height);
    if ( this.view.band ) {
      var lox = ox - this.view.band;
      if ( sx <= lox && lox <= ex )
        _drawCanvas(ctx, lox, oy, width, height);
      var rox = ox + this.view.band;
      if ( sx <= rox && rox <= ex )
        _drawCanvas(ctx, rox, oy, width, height);
    }
  },

  drawImage: function(feature, point, url, width, height, offset_x, offset_y, rotation) {
    var img = WRAP.Geo.Cache.image(url);
    if ( !img )
      return;

    if ( !width )
      width = img.width;
    if ( !height )
      height = img.height;
    if ( offset_x === undefined )
      offset_x = -width/2;
    if ( offset_y === undefined )
      offset_y = -height/2;

    if ( Array.isArray(point[0]) ) {
      for ( var i = 0 ; i < point.length ; i++ )
        this.drawImageData(feature, point[i], img, width, height, offset_x, offset_y, rotation);
    }
    else {
      this.drawImageData(feature, point, img, width, height, offset_x, offset_y, rotation);
    }
  },

  _drawLines: function(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option) {
    WRAP.Geo.check(lineDash, strokeStyle, option);
    var color = this.set(feature);
    if (!color) return;

    var lw = lineWidth || 1;
    let d;
    for ( var j = 0 ; j < lines.length ; j++ ) {
      d = [];
      var line = lines[j];
      var x = line[0][0];
      var y = line[0][1];
      var i = 0;
      d.push(`M ${x}, ${y}`);
      while ( ++i < lines[j].length ) {
        x = line[i][0];
        y = line[i][1];
        d.push(`L ${x}, ${y}`);
      }
      if ( (fillStyle || fillImage)
        || (line[0][0] == line[line.length-1][0] && line[0][1] == line[line.length-1][1]) ) {
        d.push('Z');
      }
      let stroke = 'none';
      if (strokeStyle) {
        stroke = 'black';
      }
      let fill = 'none';
      if (fillStyle || fillImage) {
        fill = 'red';
      }
      const attr = [];
      attr.push(['stroke', stroke]);
      attr.push(['stroke-width', lw + 1]);
      attr.push(['stroke-linejoin', 'round']);
      attr.push(['fill', fill]);
      attr.push(['d', d.join(' ')]);
      attr.push(['feature', color]);
      this.ctx.push(
        `<path ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
      );
    }
  },

  _addFragments: function(lines, fragments) {
    var line = this.view.renderLine(fragments);
    for ( var i = 0 ; i < line.length ; i++ )
      lines.push(line[i]);
  },

  drawPath: function(feature, path, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option, method) {
    if ( !path || !path.length )
      return;
    var lines = [];
    var ll = Array.isArray(path[0][0])?[].concat(path):[path];
    for ( var i = 0 ; i < ll.length ; i++ ) {
      if ( ll[i].length < 2 )
        continue;
      var fragments = ll[i];
      if ( method != 'SL' )
        fragments = this._fragmentPath(method, ll[i]);
      this._addFragments(lines, fragments);
    }
    this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option);
  },

  drawArc: function(feature, point, radius, start, end, lineWidth, lineDash, strokeStyle, fillStyle, fillImage) {
    var path = [];
    var circle = false;
    if ( start == end || Math.abs(end-start) > 360 ) {
      var circle = true;
      start = 0;
      end = 360;
    }
    var step = 1;
    if ( radius < 500000 )
      step = 5;
    else if ( radius < 100000 )
      step = 2;
    radius /= 1851.8518518518517;
    for ( var r = start ; r < end ; r+=step ) {
      var pos = WRAP.Geo.Util.gcPos(point[1], point[0], r, radius);
      path.push([pos.lon, pos.lat]);
    }
    var pos = WRAP.Geo.Util.gcPos(point[1], point[0], end, radius);
    path.push([pos.lon, pos.lat]);

    if ( path.length < 2 )
      return;
    var lines = [];
    var fragments = this._fragmentPath('GC', path);
    this._addFragments(lines, fragments);
    if ( circle ) {
      this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, null);
    }
    else {
      if ( fillStyle || fillImage ) {
        var polygons = [];
        path.push(point);
        path.unshift(point);
        var fragments = this._fragmentPath('GC', path);
        this._addFragments(polygons, fragments);
        this._drawLines(feature, polygons, lineWidth, null, null, fillStyle, fillImage, null);
      }
      this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, null, null, null);
    }
  },

  drawPoint: function(feature, point, size) {
    var color = this.set(feature);
    if (!color) return;

    const _drawPoint = (ctx, ox, oy) => {
      const attr = [];
      attr.push(['cx', ox]);
      attr.push(['cy', oy]);
      attr.push(['r', size/2 - 1]);
      attr.push(['fill', 'red']);
      attr.push(['feature', color]);
      ctx.push(
        `<circle ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
      );
    }

    var p = this.view.renderPoint(point);
    var ctx = this.ctx;
    var ox = p[0];
    var oy = p[1];

    var sx = -size;
    var ex = this.svg.viewBox.baseVal.width+size;
    var sy = -size;
    var ey = this.svg.viewBox.baseVal.height+size;
    if ( oy < sy || ey < oy )
      return;
    if ( sx <= ox && ox <= ex ) {
      _drawPoint(ctx, ox, oy);
    }
    if ( this.view.band ) {
      var lox = ox - this.view.band;
      if ( sx <= lox && lox <= ex ) {
        _drawPoint(ctx, lox, oy);
      }
      var rox = ox + this.view.band;
      if ( sx <= rox && rox <= ex ) {
        _drawPoint(ctx, rox, oy);
      }
    }
  },

  drawLine: function(feature, point, path, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option, rotation) {
    var p = this.view.renderPoint(point);
    var ox = p[0];
    var oy = p[1];
    var cosr, sinr;
    if ( rotation ) {
      cosr = Math.cos(Math.PI*rotation/180.0);
      sinr = Math.sin(Math.PI*rotation/180.0);
    }

    var ll = Array.isArray(path[0][0])?[].concat(path):[path];
    var lines = [];
    for ( var j = 0 ; j < ll.length ; j++ ) {
      var p = ll[j];
      var line = [];
      var max_x = this.view.extent[0]*2;
      var min_x = -this.view.extent[0];
      var max_y = this.view.extent[1]*2;
      var min_y = -this.view.extent[1];
      for ( var i = 0 ; i < p.length ; i++ ) {
        var x = p[i][0];
        var y = p[i][1];
        if ( rotation ) {
          var tx = x*cosr-y*sinr;
          var ty = x*sinr+y*cosr;
          x = tx, y = ty;
        }
        if ( min_x > x )
          min_x = x;
        if ( max_x < x )
          max_x = x;
        if ( min_y> y )
          min_y = y;
        if ( max_y < y )
          max_y = y;
        line.push([x+ox, y+oy]);
      }
      var rr = this.view.wrapAround(line, this.view.extent[0], this.view.extent[1], this.view.band,
        min_x+ox, min_y+oy, max_x+ox, max_y+oy);
      lines = lines.concat(rr);
    }
    this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option);
  },

  drawText: function(feature, point, text, fontSize, fillStyle, strokeStyle, offset_x, offset_y, align, rotation) {
    WRAP.Geo.check(fillStyle);
    var color = this.set(feature);
    if (!color) return;

    const _drawText = (ctx, x, y, ox, oy, w, h) => {
      const attr = [];
      if ( rotation ) {
        const transform = [];
        transform.push(`rotate(${rotation}, ${x}, ${y})`);
        transform.push(`translate(${ox}, ${oy})`);
        if ( strokeStyle ) {
          x-=1, y-=1;
          w+=2, h+=2;
        }
        attr.push(['x', x]);
        attr.push(['y', y-h*0.8]);
        attr.push(['width', w]);
        attr.push(['height', h]);
        attr.push(['transform', transform.join(' ')]);
      } else {
        if ( strokeStyle ) {
          x-=1, y-=1;
          w+=2, h+=2;
        }
        attr.push(['x', x+ox]);
        attr.push(['y', y+oy-h*0.8]);
        attr.push(['width', w]);
        attr.push(['height', h]);
      }
      attr.push(['fill', 'pink']);
      attr.push(['feature', color]);
      ctx.push(
        `<rect ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
      )
    }

    var ctx = this.ctx;
    var ox = parseFloat(offset_x) || 0;
    var oy = parseFloat(offset_y) || 0;
    var a = WRAP.Geo.getTextMetrics(text, fontSize || 10);
    if ( align == 'left' ) {
      ox += 0;
    } else if ( align == 'right') {
      ox -= a[0];
    } else {
      ox -= a[0]*0.5;
    }

    var p = this.view.renderPoint(point);
    var x = p[0];
    var y = p[1];

    var size = a[0];
    var h = fontSize;
    var sx = -size-ox;
    var ex = this.svg.viewBox.baseVal.width+size-ox;
    var sy = -size;
    var ey = this.svg.viewBox.baseVal.height+size;
    if ( y < sy || ey <= y )
      return;
    if ( sx <= x && x <= ex ) {
      _drawText(ctx, x, y, ox, oy, size, h);
    }
    if ( this.view.band ) {
      var lx = x - this.view.band;
      if ( sx <= lx && lx <= ex ) {
        _drawText(ctx, lx, y, ox, oy, size, h);
      }
      var rx = x + this.view.band;
      if ( sx <= rx && rx <= ex ) {
        _drawText(ctx, rx, y, ox, oy, size, h);
      }
    }
  },

  drawTile: function(feature) {
    this.set(feature, true);
  },

  drawFlow: function(feature) {
    this.set(feature, true);
  },
});
/* eslint-enable */